module.exports = __webpack_public_path__ + "img/img1.0379bbe5.jpg";